// extracted by mini-css-extract-plugin
export var contactString = "iconTextPair-module--contactString--0f62e";
export var iconTextPair = "iconTextPair-module--iconTextPair--54b86";
export var lightColor = "iconTextPair-module--lightColor--2a337";